import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import 'vite/modulepreload-polyfill'

import router from '@/web-app/routes/router'
import { CurrentWebUserProvider } from '@/web-app/providers/current-user-provider'
import { PusherProvider } from '@/shared/providers/pusher-provider'
import { initSentryPerhaps } from '@/shared/utils/sentry'
import { queryClient } from '@/shared/utils/api'
import { initPageProps } from '@/shared/utils/window'

import '@/web-app.css'
import { QueryClientProvider } from '@tanstack/react-query'

initPageProps()
initSentryPerhaps()

if (import.meta.env.DEV) {
  window.__TANSTACK_QUERY_CLIENT__ = queryClient
}

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <PusherProvider>
      <CurrentWebUserProvider>
        <RouterProvider router={router} />
      </CurrentWebUserProvider>
    </PusherProvider>
  </QueryClientProvider>,
)
